import React from 'react';
import styled from 'styled-components' ;
import * as palette from '../../../../hoc/Layout/Theme'
import styles from "../../../../styles/materialDesign.module.css"



const Error = styled.div`
    color: ${palette.errorRed};
    font-size: 12px;
    text-align: left;
    padding: 5px 0px;
    position: "absolute";
    display: ${({ show}) => (show ? 'inline' : 'none')};
    transition: all 0.3s ease;
`

const MaterialTextarea = ({field, width, label, form: {touched, errors}, ...props }) => {
    return (
        <div className={styles.formGroup}>
            <textarea {...field} {...props} />
            {/* <StyledInput width={width} {...field} {...props} /> */}
            <label className={styles.control-label} htmlFor={field.name} value="">{label}</label>
            <i className={styles.bar}></i>
            <Error show={errors[field.name] && touched[field.name]}>{errors[field.name]}</Error>
        </div>
        );
}
 
export default MaterialTextarea;